import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as TemplateActionCreators from "../../../../actions/template.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import { LocalForm, Control } from 'react-redux-form';
import { TemplateSortBy, sortTemplates } from '../../../../helpers/graphHelper';
import PaginatedTable, { ISortOption } from '../../../Data/PaginatedTable/PaginatedTable';
import { Link } from 'react-router-dom';
import * as queryString from 'query-string';
import withSortByQuery from '../../../Data/PaginatedTable/withSortByQuery';
import PlotSelect, { IPlotSelectOption } from '../../../Common/PlotSelect';

type PageAdminTemplatesProps = {
}

type PageAdminTemplatesActions = {
}

type PageAdminTemplatesRouteParams = {
}

type PageAdminTemplatesQueryParams = {
    search: string;
}

type PageAdminTemplatesPropsMapped = {
    templates: DTOS.Template[];
    templatesLoading: boolean;
}

type PageAdminTemplatesActionsMapped = {
    searchTemplates: typeof TemplateActionCreators.searchTemplatesRequest;
}

type PageAdminTemplatesAllPropsInherited = PageAdminTemplatesProps & PageAdminTemplatesActions;
type PageAdminTemplatesAllPropsMapped = PageAdminTemplatesPropsMapped & PageAdminTemplatesActionsMapped;

type PageAdminTemplatesAllProps = IBasePageProps<PageAdminTemplatesRouteParams, PageAdminTemplatesQueryParams> & Partial<PageAdminTemplatesAllPropsMapped> & PageAdminTemplatesAllPropsInherited;

interface IPageAdminTemplatesState {
    plotOptionValue: IPlotSelectOption;
}

class PageAdminTemplates extends React.Component<PageAdminTemplatesAllProps, any> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            plotOptionValue: undefined,
        }
    }

    componentDidMount() {
        this.props.searchTemplates(this.props.queryParams.search, undefined);
    }

    componentDidUpdate(prevProps: PageAdminTemplatesAllProps) {
        if (prevProps.queryParams.search != this.props.queryParams.search) {
            this.props.searchTemplates(this.props.queryParams.search, undefined);
        }
    }

    updateQuery(search: { searchText: string }) {
        var currentQueryString = queryString.parse(this.props.location.search);

        currentQueryString.search = search.searchText !== '' ? search.searchText : undefined;

        const newQueryString = queryString.stringify(currentQueryString);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: '?' + newQueryString
        });
    }

    onPlotChange(plot) {
        this.setState({
            plotOptionValue: plot
        });
    }

    render() {

        const templateSearchForm = <LocalForm
            model="search"
            onSubmit={search =>
                this.updateQuery(search)
            }
            validateOn="submit"
            className="form form-inline col-12 my-2"
        >
            <div className="input-group w-xl-30 w-100">
                <Control.text
                    defaultValue={this.props.queryParams.search}
                    model=".searchText"
                    id="searchText"
                    placeholder=""
                    className="form-control"
                    maxLength={100}
                />
                <div className="input-group-append">
                    <button className="btn btn-primary">Search</button>
                </div>
            </div>
        </LocalForm>;


        const SortTemplatesChoices: ISortOption[] = [
            { value: TemplateSortBy.ID, label: 'ID' },
            { value: TemplateSortBy.NAME, label: 'Template Name' },
            { value: TemplateSortBy.LAYOUTNAME, label: 'Layout Name' },
        ]

        const TemplatesTable = withSortByQuery(PaginatedTable);

        const args = {
            argPlotId: this.state.plotOptionValue ? this.state.plotOptionValue.plotId : undefined,
        }

        const renderArgs = queryString.stringify(args);
        const queryArgs = renderArgs && renderArgs !== '' ? '?' + renderArgs : '';

        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            {templateSearchForm}
            <hr className="w-100" />
            <div className="col-12">
                <h4>View Email As:</h4>
                <div className="row">
                    <label className="col-md-2 col-form-label">Site:</label>
                    <div className="col-md-4 col">
                        <PlotSelect
                            disabled={false}
                            onChange={this.onPlotChange.bind(this)}
                            value={this.state.plotOptionValue}
                        />
                    </div>
                </div>
            </div>
            <hr className="w-100" />
            <div className="col-12">
                <TemplatesTable
                    countPerPage={25}
                    data={this.props.templates}
                    dataColumns={[
                        { label: "ID", dataKey: "id" },
                        {
                            label: "Layout Name",
                            dataKey: "layoutName",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        { label: "Template Name", dataKey: "name" },
                        {
                            label: "Description",
                            dataKey: "description",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "View",
                            dataKey: undefined,
                            render: (t: DTOS.Template) => <Link target="_blank" className="text-nowrap" to={`/api/template/${t.id}/render${queryArgs}`}><i className="btn-primary fa fa-eye p-2"></i></Link>
                        },
                    ]}
                    dataLoading={this.props.templatesLoading}
                    dataSortOptions={SortTemplatesChoices}
                    sort={sortTemplates}
                    tableClassName={"table-sm table-bordered table-hover"}
                />
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminTemplatesAllProps): PageAdminTemplatesPropsMapped => {

    return {
        templates: state.template.templates,
        templatesLoading: state.template.templatesLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminTemplatesActionsMapped>({
        searchTemplates: TemplateActionCreators.searchTemplatesRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminTemplates);